/**
 * Created by Administrator on 2017/8/16 0016.
 */
import { Injectable } from '@angular/core';
import { StorageService } from '../providers/service/storageservice';
@Injectable()
export class AppState {
  _state:any  = {}
  colorTheme:string =  StorageService.getObj('colorTheme');
  messNum:string = StorageService.getObj('messNum');
  lctodoNum:string = StorageService.getObj('lctodoNum');
  slidesShow:any = StorageService.getObj('slidesShow');
  constructor() {
  }

  get state() {
    return this._state = this._clone(this._state);
  }

  set state(value) {
    throw new Error('do not mutate the `.state` directly');
  }
  get(prop?: any) {
    const state = this.state;
    return state.hasOwnProperty(prop) ? state[prop] : state;
  }
  set(prop: string, value: any) {
    return this._state[prop] = value;
  }
  _clone(object:any) {
    return JSON.parse(JSON.stringify(object));
  }

  setTheme(value:any){
    this.colorTheme = value;
  }
  getTheme(){
    return this.colorTheme ;
  }

}



// WEBPACK FOOTER //
// ./src/app/app.global.ts